import InfoIcon from '@mui/icons-material/Info';
import { Button, ButtonProps } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import InfoDrawer from "./InfoDrawer";
import TooltipComponent from "./TooltipComponent";

export interface DrawerButtonProps {
    tooltip?: string
    buttonContent?: JSX.Element
    children: JSX.Element
    entityUuid?: string
    open?: boolean
    setOpen?: (open: boolean) => void
    onClose?: () => void
}

export default function DrawerButton(props: DrawerButtonProps & ButtonProps) {
    const { t } = useTranslation()
    const [defaultOpen, setDefaultOpen] = React.useState(false);
    const open = props.open != undefined ? props.open : defaultOpen;
    const setOpen = props.setOpen ?? setDefaultOpen;
    return (
        <>
            <Button {...props} onClick={() => setOpen(true)}>
                <TooltipComponent title={t(props.tooltip ?? "Details") + ""}>
                    {
                        props.buttonContent ?? <InfoIcon />
                    }
                </TooltipComponent>
            </Button>
            <InfoDrawer
                open={open}
                onClose={() => {
                    setOpen(false);
                    props.onClose?.();
                } }
                entityUuid={props.entityUuid}
            >
                {props.children}
            </InfoDrawer>
        </>
    )
}